import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import SideMenu from './side-menu';
import {
  DASHBOARD_LAYOUT_MAX_WIDTH,
  DASHBOARD_LAYOUT_CONTENT_MAX_WIDTH,
  DASHBOARD_LAYOUT_CHILDREN_MAX_WIDTH,
} from './dashboard-layout-constants';

export {
  DASHBOARD_LAYOUT_MAX_WIDTH,
  DASHBOARD_LAYOUT_CONTENT_MAX_WIDTH,
  DASHBOARD_LAYOUT_CHILDREN_MAX_WIDTH,
  CHAT_WEB_COLUMN_HEIGHT_RATIO,
} from './dashboard-layout-constants';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <View style={styles.container}>
      <View style={styles.mainContent}>
        <View style={styles.bodyContainer}>
          <SideMenu />

          <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollViewContent} nestedScrollEnabled>
            <View style={styles.childrenContainer}>{children}</View>
          </ScrollView>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  mainContent: {
    flex: 1,
    flexDirection: 'column',
  },
  bodyContainer: {
    flex: 1,
    flexDirection: 'row',
    maxWidth: DASHBOARD_LAYOUT_MAX_WIDTH,
    marginHorizontal: 'auto',
    width: '100%',
  },
  scrollView: {
    flex: 1,
    maxWidth: DASHBOARD_LAYOUT_CONTENT_MAX_WIDTH,
    paddingHorizontal: 32,
  },
  scrollViewContent: {
    flexGrow: 1,
  },
  childrenContainer: {
    flex: 1,
    width: '100%',
    maxWidth: DASHBOARD_LAYOUT_CHILDREN_MAX_WIDTH,
    alignSelf: 'center',
  },
});
